import { render } from "./NutritionalPropertiesList.vue?vue&type=template&id=4d11e44f&scoped=true"
import script from "./NutritionalPropertiesList.vue?vue&type=script&lang=js"
export * from "./NutritionalPropertiesList.vue?vue&type=script&lang=js"

import "./NutritionalPropertiesList.vue?vue&type=style&index=0&id=4d11e44f&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d11e44f"],['__file',"resources/js/modules/product-categorization-drag-drop/components/filter/NutritionalPropertiesList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4d11e44f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4d11e44f', __exports__)) {
    api.reload('4d11e44f', __exports__)
  }
  
  module.hot.accept("./NutritionalPropertiesList.vue?vue&type=template&id=4d11e44f&scoped=true", () => {
    api.rerender('4d11e44f', render)
  })

}


export default __exports__